const WIDGET_TEMPLATES = {
  SWITCH: {
    id: 'switch-advanced',
    type: 'SWITCH',
    routes: [
      { goto: null, signal: 'NO_MATCH', criteria: null },
      {
        goto: null,
        signal: 'MATCH',
        criteria: [
          { value: 'yes', operator: 'EQUAL', goto: null },
          { value: 'no', operator: 'EQUAL', goto: null },
        ],
      },
    ],
    attributes: { input: '{{incoming.body}}' },
  },
  SEND_MESSAGE: {
    id: 'send-message-advanced',
    type: 'SEND_MESSAGE',
    label: 'Send message',
    routes: [
      { goto: null, signal: 'SENT' },
      { goto: null, signal: 'FAILED' },
    ],
    attributes: {
      body: 'Hello {{user.name}}, your appointment is {{appointment.date}}.',
    },
  },
  SEND_MESSAGE_AND_WAIT: {
    id: 'send-message-and-wait-advanced',
    type: 'SEND_MESSAGE_AND_WAIT',
    label: 'Send message and wait for reply',
    routes: [
      { goto: null, signal: 'INCOMING_MESSAGE' },
      { goto: null, signal: 'SENT' },
      { goto: null, signal: 'FAILED' },
      { goto: null, signal: 'TIMEOUT' },
    ],
    attributes: {
      body: 'Hello {{user.name}}, please reply with yes or no.',
      timeout: 3600,
    },
  },
  MAKE_HTTP_REQUEST: {
    id: 'make-http-request-advanced',
    type: 'MAKE_HTTP_REQUEST',
    routes: [
      { goto: null, signal: 'SUCCESS' },
      { goto: null, signal: 'FAILED' },
      { goto: null, signal: 'TIMEOUT' },
    ],
    attributes: {
      body: '{"userId": "{{user.id}}"}',
      callFunction: 'GetUserDetails',
      method: 'POST',
      url: 'https://api.example.com/user',
    },
  },
  PLAY: {
    id: 'play-advanced',
    type: 'PLAY',
    routes: [{ goto: null, signal: 'AUDIO_COMPLETED' }],
    attributes: {
      body: 'Welcome, {{user.name}}! Please follow the instructions.',
      audioUrl: 'https://example.com/welcome.mp3',
    },
  },
  GATHER_INPUT_ON_CALL: {
    id: 'gather-input-advanced',
    type: 'GATHER_INPUT_ON_CALL',
    routes: [
      {
        goto: null,
        signal: 'KEY_PRESS',
        criteria: [
          { value: '1', operator: 'EQUAL', goto: null },
          { value: '2', operator: 'EQUAL', goto: null },
        ],
      },
      { goto: null, signal: 'TIMEOUT', criteria: null },
    ],
    attributes: {
      body: 'Press 1 to confirm, 2 to call support.',
      timeout: 15,
      numDigits: 1,
      stopGatherOnKeyPress: '#',
    },
  },
  SET_VARIABLE: {
    id: 'set-variable-advanced',
    type: 'SET_VARIABLE',
    routes: [{ goto: null, signal: 'SUCCESS' }],
    attributes: {
      value: '{"confirmed": true, "timestamp": "{{now}}"}',
    },
  },
  DIAL: {
    id: 'dial-advanced',
    type: 'DIAL',
    routes: [
      { goto: null, signal: 'CALL_COMPLETED', criteria: null },
      { goto: null, signal: 'HANGUP', criteria: null },
    ],
    attributes: {
      to: '+18005551234',
      body: 'Connecting you to support.',
      timeout: 30,
      onConnectUrl: '/api/support/call-connected',
      onConnectMethod: 'POST',
    },
  },
};

export default WIDGET_TEMPLATES;
